import { v5 as uuidv5 } from 'uuid';
import type { MilkSession, ReminderType } from './enums';

/** D-13 namespace. Never change it: every deterministic ID in every farm depends on it. */
export const NAMESPACE = 'ce53a5fc-c8b9-49b0-9dc5-12a309006ceb';

/** Random UUID v4 (G-1). */
export function newId(): string {
  return globalThis.crypto.randomUUID();
}

/** Deterministic UUID v5 for `name` in the project namespace (D-13). */
export function deterministicId(name: string): string {
  return uuidv5(name, NAMESPACE);
}

/** The D-13 table, one helper per record kind. */
export const recordIds = {
  milkRecord: (tenantId: string, animalId: string, date: string, session: MilkSession) =>
    deterministicId(`milk:${tenantId}:${animalId}:${date}:${session}`),
  dailyMilkUsage: (tenantId: string, date: string) => deterministicId(`usage:${tenantId}:${date}`),
  dailyCustomerSale: (tenantId: string, date: string, buyerId: string) => deterministicId(`daily-milk-sale:${tenantId}:${date}:${buyerId}`),
  dailyCustomerPayment: (tenantId: string, date: string, buyerId: string) => deterministicId(`daily-milk-payment:${tenantId}:${date}:${buyerId}`),
  eventReminder: (animalId: string, type: ReminderType, sourceEventId: string) =>
    deterministicId(`rem:${animalId}:${type}:${sourceEventId}`),
  heiferReminder: (animalId: string) => deterministicId(`rem:${animalId}:HEIFER_BREEDING`),
  protocolReminder: (animalId: string, type: ReminderType, protocolId: string, dueDate: string) =>
    deterministicId(`rem:${animalId}:${type}:${protocolId}:${dueDate}`),
  expenseFromEvent: (eventId: string) => deterministicId(`exp:event:${eventId}`),
  expenseFromRecurring: (recurringExpenseId: string, yearMonth: string) =>
    deterministicId(`exp:rec:${recurringExpenseId}:${yearMonth}`),
};

/** Expected deterministic ID of a reminder record, from its own fields. */
export function reminderIdFor(r: {
  animalId: string;
  type: ReminderType;
  sourceEventId?: string | null;
  protocolId?: string | null;
  dueDate: string;
}): string | null {
  if (r.type === 'HEIFER_BREEDING') return recordIds.heiferReminder(r.animalId);
  if (r.type === 'VACCINATION_DUE' || r.type === 'DEWORMING_DUE') {
    return r.protocolId ? recordIds.protocolReminder(r.animalId, r.type, r.protocolId, r.dueDate) : null;
  }
  return r.sourceEventId ? recordIds.eventReminder(r.animalId, r.type, r.sourceEventId) : null;
}
